import { InputText, Item, SearchForm } from 'mailup-web-components'
import {
  resetSearchCallback,
  submitSearchCallback
} from 'Pages/WorkflowStatistics/recoil/callbacks/callbacks'
import { searchState } from 'Pages/WorkflowStatistics/recoil/state/search'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilState } from 'recoil'

const Search = () => {
  const intl = useIntl()

  const [{ searchText }, setSearchText] = useRecoilState(searchState)
  const submitSearch = useRecoilCallback(submitSearchCallback, [])
  const reset = useRecoilCallback(resetSearchCallback, [])

  const onChange = (e) => {
    const newValue = e.target.value
    setSearchText((prev) => ({ ...prev, searchText: newValue }))
  }

  const onSubmit = () => {
    if (searchText.trim() === '') {
      reset()
    } else {
      submitSearch()
    }
  }

  return (
    <>
      <SearchForm
        advanced={false}
        labelBtnSearch={intl.formatMessage({ id: 'Load.MailupCommon.Search' })}
        labelBtnReset={intl.formatMessage({ id: 'Load.MailupCommon.Reset' })}
        onClickSubmit={onSubmit}
        onClickReset={reset}
      >
        <Item>
          <InputText
            placeholder={intl.formatMessage({
              id: 'Load.AutomationWorkflowTroubleshooting.SearchTextPlaceholder'
            })}
            value={searchText}
            onChange={onChange}
            data-mu-test='workflow-statistics__input-recipient'
          />
        </Item>
      </SearchForm>
    </>
  )
}

export default Search
